import type { FluxErrorEntityErrorCodes } from '../../types.js';

export const AutomationV2ExecutionActionAddCardCommentCodes = {
  AutomationV2ExecutionActionAddCardCommentFailedToAddComment: {
    code: 'automation-v2-execution-action/add-card-comment-failed-to-add-comment',
    explanation: `Erro ao salvar o comentário no card.

**Causas comuns:**
- Conteúdo do comentário inválido ou muito longo
- Permissões insuficientes para comentar
- Card bloqueado ou arquivado (dependendo da configuração)

**Como resolver:**
Verifique se o texto do comentário está dentro dos limites permitidos.`,
    localizations: {},
    message: 'A automação não conseguiu adicionar o comentário ao processo.',
    supportingDocs: [
      {
        name: 'Ação de Adicionar Comentário ao Card',
        path: '/wiki/docs/automations/actions/add-card-comment',
      },
    ],
  },
  AutomationV2ExecutionActionAddCardCommentMissingCardId: {
    code: 'automation-v2-execution-action/add-card-comment-missing-card-id',
    explanation: `ID do card é obrigatório no contexto da ação. O id do card é automaticamente passado pelo gatilho ou por ações anteriores.

**Causas comuns:**
- Variável cardId não resolvida
- Caso o valor do cardId seja mapeado manualmente, pode ter sido digitado incorretamente.
- Caso o valor do cardId não tenha sido mapeado, o \`context.card.id\` não está disponível.

**Como resolver:**
Corrija o mapeamento do ID do card.`,
    localizations: {},
    message:
      'Não foi possível adicionar o comentário ao card porque o ID do card está faltando. Verifique se o card existe no contexto da automação ou se foi digitado corretamente.',
    supportingDocs: [
      {
        name: 'Ações de Adicionar Comentário ao Card',
        path: '/wiki/docs/automations/actions/add-card-comment',
      },
      {
        name: 'Informações Dinâmicas',
        path: '/wiki/docs/automations/informacoes-dinamicas',
      },
    ],
  },
} as const satisfies FluxErrorEntityErrorCodes<'automation-v2-execution-action'>;
